
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/daily-digest",
      function () {
        return require("private-next-pages/daily-digest/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/daily-digest"])
      });
    }
  